import * as styles from "./Skeleton.module.scss";
import { Skeleton } from "components/Skeleton/index";
import React from "react";

const SkeletonParagraph = () => (
  <div className={styles.skeletonParagraphWrapper}>
    <Skeleton className={styles.skeletonParagraph} />
    <Skeleton className={styles.skeletonParagraph} />
    <Skeleton className={styles.skeletonParagraph} />
    <Skeleton className={styles.skeletonParagraph} />
  </div>
);

export default SkeletonParagraph;
